import type { AssistantLocale, RiskLevel } from '@munifocus/contracts-gov';
import type { StatusKind } from '@munifocus/ui';
import { frenchFirstOfMonth } from '@munifocus/utils';

/** The assistant's output language for the portal's current one. */
export function currentLocale(language: string | undefined): AssistantLocale {
  return language?.startsWith('fr') ? 'fr' : 'en';
}

/** How each risk level is coloured — the same tones as every other status. */
export const RISK_STATUS: Record<RiskLevel, StatusKind> = {
  low: 'success',
  moderate: 'warning',
  high: 'emergency',
};

/** A date or timestamp as the officer reads it. */
export function formatDay(iso: string, language: string): string {
  const d = new Date(iso.length === 10 ? `${iso}T12:00:00` : iso);
  return frenchFirstOfMonth(
    new Intl.DateTimeFormat(language.startsWith('fr') ? 'fr-CA' : 'en-CA', {
      dateStyle: 'medium',
    }).format(d),
  );
}

/** Photos the assistant can read: image types the model accepts. */
const READABLE = new Set(['image/jpeg', 'image/jpg', 'image/png', 'image/webp', 'image/gif']);

export function isAssessablePhoto(contentType: string): boolean {
  return READABLE.has(contentType.toLowerCase());
}
